import React, { Component } from "react";
import { translate } from "react-i18next";
import BlogContentCard from "./newupdateBlogTemplate";
import { gaEvent } from "../../ga/analytics";
import {
	CATEGORY_HOMEPAGE,
	ACTION_NEWS_UPDATE_MORE,
	ACTION_HR_NEWS_MORE,
	ACTION_FINANCIAL_NEWS_MORE,
} from "../../ga/constant";

class ListNewUpdate extends Component {
	sendToGa = (type) => {
		if (type === "News Update more") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_NEWS_UPDATE_MORE);
		}

		if (type === "HR News more") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_HR_NEWS_MORE);
		}

		if (type === "Financial News more") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_FINANCIAL_NEWS_MORE);
		}
	};

	componentDidMount() {
		const { getBlogs_byCat, i18n } = this.props;
		const lang = i18n.language === "en" ? "EN" : "TH";
		getBlogs_byCat(lang, "all", 30);
	}

	render() {
		function groupBy(data, key) {
			var groups = {};
			for (var i in data) {
				if (!groups.hasOwnProperty(data[i][key])) groups[data[i][key]] = [];
				groups[data[i][key]].push(data[i]);
			}
			return groups;
		}

		const { t, i18n, blogs, blogLoading } = this.props;

		const {
			debtclinic,
			cashflowandworklife,
			daycashproduct,
			ourmoneytablecompany,
		} = groupBy(blogs.data, "category_clean_name");
		// const url_lang = i18n.language === "en" ? "/en" : "";
		return (
			<div className={`newupdate ${i18n.language}`}>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<h1 className="main-title text-center">
								{t("money_liter_title")}
							</h1>
						</div>
						<div className="col-md-3 newupdate--maincontent">
							{/* <h5
								className={`newupdate--maincontent--title${
									i18n.language === "th" ? "--th" : ""
								}`}
							>
								{t("newupdate-title")}
							</h5> */}
							<div className="clearfix" />
							{/* <hr
								style={{ borderTop: "solid 1px #c5c5c5", marginTop: "0px" }}
							/> */}

							<BlogContentCard
								data={debtclinic}
								loading={blogLoading}
								type="Debt Clinic"
							/>

							<div className="clearfix" />
							{/* <a
								href={`${url_lang}/blog`}
								className={`pull-right txt--${i18n.language}`}
								onClick={() => this.sendToGa("News Update more")}
							>
								{t("newupdate-title-all")} »
							</a> */}
						</div>
						<div className="col-md-3 newupdate--maincontent">
							{/* <h5
								className={`newupdate--maincontent--title${
									i18n.language === "th" ? "--th" : ""
								}`}
							>
								{t("hrnews")}
							</h5> */}
							<div className="clearfix" />
							{/* <hr
								style={{ borderTop: "solid 1px #c5c5c5", marginTop: "0px" }}
							/> */}

							<BlogContentCard
								data={cashflowandworklife}
								loading={blogLoading}
								type="Cashflow and Work Life"
							/>

							<div className="clearfix" />
							{/* <a
								onClick={() => this.sendToGa("HR News more")}
								href={`${url_lang}/blog/hr%20tips`}
								className={`pull-right txt--${i18n.language}`}
							>
								{t("newupdate-title-all")} »
							</a> */}
						</div>
						<div className="col-md-3 newupdate--maincontent">
							{/* <h5
								className={`newupdate--maincontent--title${
									i18n.language === "th" ? "--th" : ""
								}`}
							>
								{t("finews")}
							</h5> */}
							<div className="clearfix" />
							{/* <hr
								style={{ borderTop: "solid 1px #c5c5c5", marginTop: "0px" }}
							/> */}

							<BlogContentCard
								data={daycashproduct}
								loading={blogLoading}
								type="DayCash Product"
							/>

							<div className="clearfix" />
							{/* <a
								onClick={() => this.sendToGa("Financial News more")}
								href={`${url_lang}/blog/financial`}
								className={`pull-right txt--${i18n.language}`}
							>
								{t("newupdate-title-all")} »
							</a> */}
						</div>
						<div className="col-md-3 newupdate--maincontent">
							{/* <h5
								className={`newupdate--maincontent--title${
									i18n.language === "th" ? "--th" : ""
								}`}
							>
								{t("finews")}
							</h5> */}
							<div className="clearfix" />
							{/* <hr
								style={{ borderTop: "solid 1px #c5c5c5", marginTop: "0px" }}
							/> */}

							<BlogContentCard
								data={ourmoneytablecompany}
								loading={blogLoading}
								type="Our Moneytable Company"
							/>

							<div className="clearfix" />
							{/* <a
								onClick={() => this.sendToGa("Financial News more")}
								href={`${url_lang}/blog/financial`}
								className={`pull-right txt--${i18n.language}`}
							>
								{t("newupdate-title-all")} »
							</a> */}
						</div>
					</div>
				</div>
				{/* end container */}
			</div>
		);
	}
}

export default translate("translations")(ListNewUpdate);



// WEBPACK FOOTER //
// ./src/components/common/newupdateBlog.jsx